import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ChevronDown } from 'lucide-react';
import { MenuItem, RED } from './NavMenu';

// Phone/tablet drawer: hamburger → full-height panel with accordion groups (all groups with an active page start expanded).
export const MobileNav = ({ groups, dashboard, isGroupActive, badgeTotal, footer }) => {
  const [open, setOpen] = useState(false);
  const [expanded, setExpanded] = useState({});
  const location = useLocation();
  useEffect(() => { setOpen(false); }, [location.pathname, location.search]);
  useEffect(() => { setExpanded(Object.fromEntries(groups.map((g) => [g.id, isGroupActive(g)]))); }, [open]); // eslint-disable-line
  const total = groups.reduce((a, g) => a + badgeTotal(g), 0);
  return (
    <>
      <button type="button" className="dw-nav-burger" aria-label="Open menu" aria-expanded={open} data-testid="mobile-nav-toggle" onClick={() => setOpen(true)}
        style={{ display: 'none', position: 'relative', background: 'transparent', border: '1px solid rgba(255,255,255,0.2)', borderRadius: 8, color: '#fff', padding: 8, cursor: 'pointer' }}>
        <Menu size={20} />
        {total > 0 && <span style={{ position: 'absolute', top: -4, right: -4, width: 10, height: 10, borderRadius: 99, background: RED }} />}
      </button>
      {open && (
        <div role="dialog" aria-modal="true" data-testid="mobile-nav-drawer" style={{ position: 'fixed', inset: 0, zIndex: 100, display: 'flex' }}>
          <div onClick={() => setOpen(false)} style={{ flex: 1, background: 'rgba(0,0,0,0.55)' }} />
          <div style={{ width: 'min(86vw, 340px)', background: '#16213e', color: '#fff', display: 'flex', flexDirection: 'column', boxShadow: '-10px 0 40px rgba(0,0,0,0.5)' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '14px 16px', borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
              <b style={{ fontSize: 15 }}>Menu</b>
              <button type="button" aria-label="Close menu" data-testid="mobile-nav-close" onClick={() => setOpen(false)} style={{ background: 'transparent', border: 'none', color: '#fff', cursor: 'pointer', padding: 6 }}><X size={20} /></button>
            </div>
            <nav style={{ flex: 1, overflowY: 'auto', padding: 8 }}>
              <MenuItem item={dashboard} mobile />
              {groups.map((g) => {
                const Icon = g.icon;
                const isOpen = expanded[g.id];
                const act = isGroupActive(g);
                return (
                  <div key={g.id} style={{ marginTop: 4 }}>
                    <button type="button" aria-expanded={!!isOpen} data-testid={`mobile-nav-group-${g.id}`} onClick={() => setExpanded({ ...expanded, [g.id]: !isOpen })}
                      style={{ width: '100%', display: 'flex', alignItems: 'center', gap: 10, padding: '12px 14px', borderRadius: 8, border: 'none', cursor: 'pointer', fontSize: 14, fontWeight: 700, color: '#fff', background: act ? 'rgba(231,76,60,0.25)' : 'rgba(255,255,255,0.05)' }}>
                      {Icon && <Icon size={16} />}<span style={{ flex: 1, textAlign: 'left' }}>{g.label}</span>
                      {badgeTotal(g) > 0 && <span style={{ fontSize: 11, fontWeight: 800, background: '#f59e0b', color: '#111', borderRadius: 10, padding: '1px 7px' }}>{badgeTotal(g)}</span>}
                      <ChevronDown size={16} style={{ transform: isOpen ? 'rotate(180deg)' : 'none', transition: 'transform .15s' }} />
                    </button>
                    {isOpen && <div style={{ padding: '4px 0 4px 10px' }}>{g.items.map((it) => <MenuItem key={it.to + it.label} item={it} mobile />)}</div>}
                  </div>
                );
              })}
            </nav>
            <div style={{ borderTop: '1px solid rgba(255,255,255,0.1)', padding: 12 }}>{footer}</div>
          </div>
        </div>
      )}
      <style>{`
        @media (max-width: 1279px) { .dw-nav-desktop { display: none !important; } .dw-nav-burger { display: inline-flex !important; } }
        @media (max-width: 1439px) { .dw-nav-user-name { display: none !important; } .dw-nav-group-icon { display: none !important; } .dw-nav-label-long { display: none !important; } .dw-nav-label-short { display: inline !important; } }
        .dw-nav-label-short { display: none; }
      `}</style>
    </>
  );
};

export const PlainLink = ({ item, active }) => {
  const Icon = item.icon;
  return (
    <Link to={item.to} data-testid={item.testId} aria-current={active ? 'page' : undefined}
      style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '8px 12px', borderRadius: 6, fontSize: 14, color: '#fff', textDecoration: 'none', background: active ? RED : 'transparent', whiteSpace: 'nowrap' }}>
      {Icon && <Icon size={16} />} {item.label}
    </Link>
  );
};
